import { FC } from 'react';
import { orderDetailsState } from '../../../../../../../pages/order/edit/states/orderDetails/orderDetails.state';
import { PinnedText } from '../../../../../pinnedText/pinnedText.component';
import { useMediaQuery } from '@mui/material';

export const NotePinned: FC<INotePinned> = ({ isNotePinned }) => {
  const isFullHd = useMediaQuery('(min-width:1920px)');
  const handleUnpinClick = () => {
    orderDetailsState.pub.updateIsNotePinned(false, isFullHd);
  };

  return (
    <PinnedText
      name='note'
      isPinned={!!isNotePinned}
      handleUnpinClick={handleUnpinClick}
      type='editor'
    />
  );
};

interface INotePinned {
  isNotePinned?: boolean;
}
